import type { Observable } from 'rxjs';
import type { DocumentTypeOption } from '../models/commerce-landing.model';

export abstract class DocumentTypePort {
  abstract loadByCountry(codPais: string): Observable<DocumentTypeOption[]>;
}
